import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

type ExternalPageData = {
  title: string;
  subtitle: string;
  url: string;
};

@Component({
  selector: 'app-appolo-gestion',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './appolo-gestion.component.html',
})
export class AppoloGestionComponent {
  readonly title: string;
  readonly subtitle: string;
  readonly iframeUrl: SafeResourceUrl;

  constructor(route: ActivatedRoute, sanitizer: DomSanitizer) {
    const data = route.snapshot.data as Partial<ExternalPageData>;
    this.title = data.title ?? 'Appolo Gestion';
    this.subtitle = data.subtitle ?? 'Panel integrado';
    this.iframeUrl = sanitizer.bypassSecurityTrustResourceUrl(data.url ?? 'https://appolo.eu/');
  }
}
